import './pane-right-traffic-lights.scss';
import { useCallback, useContext, useState, useEffect } from 'react';
import { TasksCounterContext } from '../context/tasks-counter-context';

const TrafficLights = ({ handleTrafficLightsChange }) => {

            // Complete = 0,
            // New = 1,
            // Overdue = 2,
            // Future = 3,
            // Uncomplete = 4,
            // Execute = 5,
            // RedPriority = 6,
            // YellowPriority = 7,
            // GreenPriority = 8,
            // WithoutPriority = 9,

    const [counter, setCounter] = useContext(TasksCounterContext);
    const [localTasksCounter, setLocalTasksCounter] = useState(counter);
    const [color, setColor] = useState(0);
    
    useEffect(() => {
        setLocalTasksCounter(counter);
    }, [counter]);


    const handleChangeRed = () => {
        if (color === 1) {
            setColor(0);
            handleTrafficLightsChange(null);
        }
        else {
            setColor(1);
            handleTrafficLightsChange(1);
        }
    };

    const handleChangeYellow = () => {

        if (color === 2) {
            setColor(0);
            handleTrafficLightsChange(null);
        }
        else {
            setColor(2);
            handleTrafficLightsChange(2);
        }
    };

    const handleChangeGreen = () => {

        if (color === 3) {
            setColor(0);
            handleTrafficLightsChange(null);
        }
        else {
            setColor(3);
            handleTrafficLightsChange(3);
        }

    };

    const handleChangeNormal = () => {
        // Call the handleRecipientChange function from props

        if (color === 4) {
            setColor(0);
            handleTrafficLightsChange(null);
        }
        else {
            setColor(4);
            handleTrafficLightsChange(4);
        }

    };

    const handleChangeFuture = () => {
        // Call the handleRecipientChange function from props

        if (color === 5) {
            setColor(0);
            handleTrafficLightsChange(null);
        }
        else {
            setColor(5);
            handleTrafficLightsChange(5);
        }

    };


    return (
        <div className="traffic-lights-container">
            <div title="Червоний пріоритет"
                className={color == 1 ? "traffic-lights-item-red traffic-lights-item-selected" : "traffic-lights-item-red"}
                onClick={handleChangeRed} >
                {localTasksCounter[6].length}
            </div>
            <div title="Жовтий пріоритет"
                className={color == 2 ? "traffic-lights-item-yellow traffic-lights-item-selected" : "traffic-lights-item-yellow"}
                onClick={handleChangeYellow} >
                {localTasksCounter[7].length}
            </div>
            <div title="Зелений пріоритет"
                className={color == 3 ? "traffic-lights-item-green traffic-lights-item-selected" : "traffic-lights-item-green"}
                onClick={handleChangeGreen} >
                {localTasksCounter[8].length}
            </div>
            <div title="Немає пріоритету"
                className={color == 4 ? "traffic-lights-item-normal traffic-lights-item-selected" : "traffic-lights-item-normal"}
                onClick={handleChangeNormal} >
                {localTasksCounter[9].length}
            </div>
            <div style={{visibility:'hidden'}}
                className={"traffic-lights-item-normal"}>
            </div>
            
            <div title="На майбутнє"
                className={color == 5 ? "traffic-lights-item-future traffic-lights-item-selected" : "traffic-lights-item-future"}
                onClick={handleChangeFuture} >
                {localTasksCounter[3].length}
            </div>

        </div>
    );
};

export default TrafficLights;



